import React, { Component, useState, useEffect } from "react";
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
// import CustomNumberInput from "../number-input";
import { NumberField as CustomNumberInput } from "../NumberField";
import IconButton from '@mui/material/IconButton';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import FormControl, { useFormControl } from '@mui/material/FormControl';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Switch from '@mui/material/Switch';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import Tooltip from '@mui/material/Tooltip';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { netGet, netPost } from '../network';
import { from } from "rxjs";


const DATE_FORMAT = 'DD MMM YYYY';

function ChooseDateDialog(props) {
    const {
        title = 'Add Revision Record Date',
        open,
        onSave,
        onCancel,
        ...other
    } = props;
    const [revdateValue, setRevdateValue] = React.useState(dayjs());

    /*
    React.useEffect( () => {
        
    }, [open]);
    */

    const onOKClick = () => {
        if ( typeof onSave === 'function' ) {
            let outOptions = {
                revdate: revdateValue, 
            };
            onSave(outOptions);
        }
    }

    const onCancelClick = () => {
        onClose();
    };

    const onClose = (event, reason) => {
        if ( reason === 'backdropClick') {
            return;
        }
        if ( typeof onCancel === 'function' ) {
            onCancel();
        }
    };

    const revdateChanged = (newvalue) => {
        // console.log('revdate: ' + newvalue);
        setRevdateValue(newvalue);
    }

 
    return (
        <Dialog
            maxWidth={'400px'}
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {
                  minWidth: 400,
                  maxHeight: 600
                }
              }}
        >
            <DialogTitle sx={{fontWeight: 'bold'}}>{title}</DialogTitle>
            <DialogContent>
                <Box sx={{width: '100%'}}>
                        <DatePicker label="Revision Date" value={revdateValue} format={DATE_FORMAT}
                            onChange={revdateChanged} sx={{ marginTop: '1ex', marginBottom: '2ex' }} />

                </Box>
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={onOKClick} sx={{minWidth: '7em'}} >Add</Button>
                <Button variant="outlined" onClick={onCancelClick} sx={{minWidth: '7em'}}>Cancel</Button>
            </DialogActions>
        </Dialog>

    );

}

function RevisionRecordConfig (props) {
    const {
        doc,
        open,
        onChange,
        saveEnabled = true,
        readOnly = false,
        ...other
    } = props;

    const [limited, setLimited] = useState(true);
    const [numRecords, setNumRecords] = useState(100);
    const [configKey, setConfigKey] = useState(null);
    const [records, setRecords] = useState([]);
    const [effectivities, setEffectivities] = useState([]);
    const [operator, setOperator] = useState('NZ');
    const [selectedIndex, setSelectedIndex] = useState(-1);
    const [openDateDialog, setOpenDateDialog] = useState(false);
    const [numberChanged, setNumberChanged] = useState(false);
    const [recordsChanged, setRecordsChanged] = useState(false);

    useEffect(() => {
        netGet('/config/realm')
          .then(response => response.json())
          .then(rinfo => {
            if (rinfo?.realm) {
              setOperator(rinfo.realm);
            }
          }).catch(error => {
            console.log('Error fetching realm name: ' + error);
          });
      }, []);

    useEffect( () => {
            if ( open &&  doc ) {
                setNumberChanged(false);
                setRecordsChanged(false);
                
                let key = `${doc['configBaseKey']}.workflow.revision-record.numberOfRecords`;
                if ( doc['configBaseKey'] ) {
                    setConfigKey(key);
                    loadNumberOfRecords(key);
                } else {
                    setConfigKey(null);
                    if (doc.document) {
                        netGet('/api/doc/info/' + encodeURIComponent(doc.document))
                            .then(response => response.json())
                            .then(docInfo => {
                                if (docInfo['configBaseKey']) {
                                    key = `${docInfo['configBaseKey']}.workflow.revision-record.numberOfRecords`;
                                    setConfigKey(key);
                                    loadNumberOfRecords(key);
                                }
                            }).catch(error => {
                                console.log('Error fetching revision records: ' + error);
                            });
                        }
                }
                /*
                // console.log('RR: key = ' + JSON.stringify(key));
                const url = `/api/config/vget?key=${key}`;
                netGet(url)
                    .then(response => response.json())
                    .then(num => {
                        // console.log('RR stored: ' + (typeof num?.v) + ' ' + JSON.stringify(num));
                        if ( typeof num.v === 'string' && num.v.length === 0 ) {
                            setLimited(true);
                            setNumRecords(100);
                        } else if ( typeof num.v === 'number' || typeof num.v === 'string' ) {
                            const value = typeof num.v === 'number' ? num.v : Number.parseInt(num.v);
                            setNumRecords(value > 0 ? value : 2);
                            setLimited( value > 0);
                        } else {
                            setLimited(true);
                            setNumRecords(100);
                        }
                        
                        
                    }).catch(error => {
                        console.log('Error fetching download profiles: ' + error);
                        setLimited(true);
                        setNumRecords(100);
                    });
                */

                netGet('/api/doc/revrec/dates/' + encodeURIComponent(doc.document))
                    .then(response => response.json() )
                    .then( dates => {
                        // console.log('Revision records for ' + doc.document + ' : ' + JSON.stringify(dates));
                        const rr = [];
                        dates.forEach( (d,index) => {
                            const rd = dayjs(d.substring(0,10));
                            rr.push({
                                revnum: index,
                                revdate: rd.format(DATE_FORMAT),
                            });
                        });
                        setRecords(rr);
                    }).catch(error => {
                        console.log('Error fetching revision records: ' + error);
                    });
                netGet('/api/doc/revrec/effs/' + encodeURIComponent(doc.document))
                    .then(response => response.json() )
                    .then( effs => {
                        // console.log('Revision record effectivities for ' + doc.document + ' : ' + JSON.stringify(effs));
                        let oper = '';
                        const ee = [];
                        effs.forEach( (reff) => {
                            const i = reff.indexOf('_');
                            let op = '';
                            let eff = ''
                            if (i >= 0) {
                                op = reff.substring(0, i);
                                eff = reff.substring(i+1);
                            }
                            if (oper.length === 0) {
                                oper = op;
                            } else if ( oper !== op ) {
                                console.log('RevRecord found different oper = ' + oper + ', ' + op);
                            }
                            ee.push({value: reff, label: eff});
                        });
                        // console.log("Revision record resolved effectivities for " + doc.document + " : " + JSON.stringify(ee));
                        setEffectivities(ee);
                    }).catch(error => {
                        console.log('Error fetching revision records: ' + error);
                    });
                
            } else {
                setNumRecords(100);
                setLimited(true);
                setNumberChanged(false);
                setRecordsChanged(false);
                setRecords([]);
            }
    
        },[doc,readOnly]);

    const loadNumberOfRecords = (key) => {
        const url = `/api/config/vget?key=${key}`;
        netGet(url)
            .then(response => response.json())
            .then(num => {
                // console.log('RR stored: ' + (typeof num?.v) + ' ' + JSON.stringify(num));
                if (typeof num.v === 'string' && num.v.length === 0) {
                    setLimited(true);
                    setNumRecords(100);
                } else if (typeof num.v === 'number' || typeof num.v === 'string') {
                    const value = typeof num.v === 'number' ? num.v : Number.parseInt(num.v);
                    setNumRecords(value > 0 ? value : 2);
                    setLimited(value > 0);
                } else {
                    setLimited(true);
                    setNumRecords(100);
                }
            }).catch(error => {
                console.log('Error fetching download profiles: ' + error);
                setLimited(true);
                setNumRecords(100);
            });
    }

    const onLimitedChanged = (value) => {
        if ( readOnly) {
            return;
        }
        setLimited(value);
        if ( value ) {
            if ( numRecords < 2 ) {
                setNumRecords(2);
            }
        } else {
            setNumRecords(-1);
        }
        onConfigChange(value, numRecords);
    };

    const onNumberRecordsChanged = (value) => {
        if ( readOnly ) {
            return;
        }
        setNumRecords(value);
        onConfigChange(limited, value);
    }

    const onConfigChange = (lim, num) => {
        if ( readOnly ) {
            return;
        }
        const value = lim ? num : -1;
        setNumberChanged(true);
        /*
        netPost(`/api/config/set?key=${configKey}`, `${value}`)
            .then(resp => {
                if (!resp.ok) {
                    console.log('Could not save rules: status = ' + resp.status);
                } else {
                    // delete def.saveSteps;
                    // setSaveDocumentEnabled(false);
                    // handleItemClick(selectedIndex);
                    // unmarkModified();
                }
            });
        */
        if (typeof onChange === 'function') {
            const config = {
                numberOfRecords: value,
                configKey: configKey,
            };
            if ( recordsChanged ) {
                config.revrec = resolveRecords(records);
            }
            onChange(config);
        }
    }

    const handleRowClick = (index) => {
        setSelectedIndex(index);
    };

    const handleAddRecordAction = () => {
        setOpenDateDialog(true);
    };

    const handleDeleteRecordAction = () => {
        if ( selectedIndex >= 0 && selectedIndex < records.length) {
            const dd = [...records];
            dd.splice(selectedIndex, 1);
            dd.forEach((d, i) => {
                d.revnum = `${i}`;
            });
            setRecords(dd);
            setSelectedIndex(-1);
            handleRecordsChanged(dd);
        }

    };

    const handleAddRecordSave = (record) => {
        setOpenDateDialog(false);
        const rd = record.revdate.format(DATE_FORMAT);
        // console.log('revdate: ' + rd);
        const dd = [...records];
        dd.push({revnum: dd.length, revdate: rd});
        dd.sort( (a,b) => dayjs(a.revdate, DATE_FORMAT).isAfter(dayjs(b.revdate, DATE_FORMAT)) ? 1 : -1);
        let index = -1;
        dd.forEach( (d, i) => {
            d.revnum = `${i}`;
            if ( rd === d.revdate) {
                index = i;
            }
        });
        setRecords(dd);
        
        setSelectedIndex(index);
        handleRecordsChanged(dd);
    };

    const resolveRecords = (rec) => {
        const dd = rec.map(r => {
            const d = dayjs(r.revdate, DATE_FORMAT);
            return d.format('YYYY-MM-DD'); // save format
        })
        const rr = {
            document: doc.document,
            dates: dd,
            effectivities: effectivities ? effectivities.map(e => e.value) : [],
        };
        return rr;
    };

    const handleRecordsChanged = (rec) => {
        setRecordsChanged(true);
        if ( typeof onChange === 'function') {
            const rr = resolveRecords(rec);
            const config = {
                revrec: rr,
            };
            if ( numberChanged ) {
                config.numberOfRecords = limited ? numRecords : -1;
            }
            onChange(config);
        }
    }

    const onRecordsIncrement = () => {
        const v = numRecords + 1;
        onNumberRecordsChanged(v);
    };

    const onRecordsDecrement = () => {
        const v = numRecords - 1;
        if ( v >= 2 ) {
            onNumberRecordsChanged(v);
        }
    };


    return (
        <Box sx={{display: 'flex', flexFlow: 'column nowrap', height: '100%'}}>
            <Typography sx={{ marginLeft: 2, marginRight: 2, marginTop: 3, fontStyle: 'italic', fontWeight: 'bold' , color: '#202020', fontSize: '105%' }}>Maximum number of records: </Typography>
            <Box sx={{ paddingTop: '2ex', display: 'flex', alignItems: 'baseline'}}>
                <FormControlLabel
                    sx={{
                        marginLeft: 3,
                        marginTop: 2,
                    }}
                    control={<Switch checked={limited} sx={{

                    }} size="small" disabled={readOnly}
                        disableTypography={false}
                        onChange={(event) => onLimitedChanged(event.target.checked)} />}
                    label={limited ? <Typography sx={{ fontWeight: 'bold' }}>Limited</Typography> : <Typography sx={{ fontWeight: 'bold' }}>Unlimited</Typography>} />
                {limited &&
                    <CustomNumberInput size="small" value={numRecords} onChange={(event) => onNumberRecordsChanged(event.target.value)} 
                        onIncrement={onRecordsIncrement} onDecrement={onRecordsDecrement}
                        sx={{marginLeft: 2}} min={2} disabled={readOnly}/>
                }
                
            </Box>
            <Typography sx={{ marginLeft: 2, marginRight: 2, marginTop: 4, fontStyle: 'italic', fontWeight: 'bold' , color: '#202020', fontSize: '105%' }}>Revision records: </Typography>
            <Box sx={{ paddingLeft: 2, paddingRight: 2, flexGrow: 1, overflow: 'hidden' }}>
                <TableContainer component={Paper} elevation={0} sx={{maxHeight: '100%'}}>
                    <Table sx={{ minWidth: 650 }} aria-label="revision record table" size="small" stickyHeader>
                        <TableHead>
                            <TableRow sx={{ fontWeight: 'bold', borderBottom: 2 }}>
                                <TableCell sx={{ fontWeight: 'bold' }}>Revision Number</TableCell>
                                <TableCell sx={{ fontWeight: 'bold' }}>Revision Date</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {records.map((record, index) => (
                                <TableRow selected={index === selectedIndex}
                                    onClick={() => handleRowClick(index)}
                                    key={`r-${doc.id}-${index}`}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0,  } }}
                                >
                                    <TableCell>
                                        {record.revnum}
                                    </TableCell>
                                    <TableCell>{record.revdate}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
            <Box sx={{marginTop: 2, padding: '1ex'}}>
                <Tooltip title="Add Revision Record">
                    <span>
                        <IconButton color="inherit" disabled={readOnly} onClick={handleAddRecordAction} sx={{ marginLeft: 2, paddingLeft: '6px', paddingRight: '6px' }}>
                            <AddIcon color="inherit" />
                        </IconButton>
                    </span>
                </Tooltip>
                <Tooltip title="Delete Selected Revision Record">
                    <span>
                        <IconButton color="inherit" disabled={readOnly || selectedIndex < 0} onClick={handleDeleteRecordAction} sx={{ marginLeft: 2, paddingLeft: '6px', paddingRight: '6px' }}>
                            <DeleteIcon color="inherit" />
                        </IconButton>
                    </span>
                </Tooltip>
            </Box>
            <ChooseDateDialog open={openDateDialog} onCancel={() => setOpenDateDialog(false)} onSave={handleAddRecordSave} />
            {/* limited &&
            <Typography sx={{ marginLeft: 3, marginTop: 4, fontSize: '90%', color: '#404040'}}>{`The revision record table will be limited to the last ${numRecords} entr`}{numRecords === 1 ? 'y.' : 'ies.'}</Typography>
            */}
        </Box>
    );

}

export { RevisionRecordConfig };